import useSWRImmutable from 'swr/immutable';
import { CompanyReviewsProviderResults, CompanyReviewsResponse } from './types';

const useCompanyReviews = (
  initialData?: CompanyReviewsResponse | null,
): CompanyReviewsProviderResults => {
  const { data: company, error } = useSWRImmutable<
    CompanyReviewsResponse | undefined
  >('/api/trustpilot/reviews', {
    fallbackData: initialData ?? undefined,
    revalidateOnMount: true,
  });

  return { company, isLoading: !company && !error };
};

export default useCompanyReviews;
